<template>
  <div :class="classes">
    <input ref="input" v-if="maska" :type="type" :required="required" :value="modelValue"
      v-maska :data-maska="maska ? maska : false"
      :class="error ? 'is-invalid' : false"
      :step="step ? step : false"
      :maxlength="maxlength ? maxlength : false"
      :min="min ? min : false"
      :max="max ? max : false"
      :placeholder="placeholder"
      @input="handleTextInput"
      @change="changeValue"
    />

    <input ref="input" v-else :type="type" :required="required" :value="modelValue"
      :step="step ? step : false"
      :class="error ? 'is-invalid' : false"
      :disabled="disabled"
      :maxlength="maxlength ? maxlength : false"
      :min="min ? min : false"
      :max="max ? max : false" @change="changeValue"
      :placeholder="placeholder"
    />

    <label :class="labelClasses" v-text="label"/>

    <div class="clear" @click="clear()" :class="{visible: clearable && modelValue?.length>0 && !disabled && !isLoading}">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.33333 9.33333L14.6667 14.6667M14.6667 9.33333L9.33333 14.6667M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
            stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </div>

    <kp-icon v-if="isSuccess" class="success-check" name="check_circle_outline" />

    <AlertBox :is-show="error && showErrorText" :message="error" />
  </div>
</template>

<script>
import {vMaska} from "maska"
import SuggestionSource from "@/api/SuggestionSource.js";

export default {
  name: 'TheInput',
  directives: { maska: vMaska },
  props: {
    modelValue: [String, Number],
    withoutAccordion: {
      type: Boolean,
      default: false,
      require: false,
    },
    showErrorText: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: null,
      require: false,
    },
    maska: {
      type: String,
      default: null,
      require: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    label_position_left: {
      type: Boolean,
      default: true,
    },
    class_value: {
      type: String,
      default: '',
    },
    subValue: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    step: {
      type: Number,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
      require: false,
    },
    updateModelOnInput: {
      type: Boolean,
      default: false
    },
    isSuccess: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    labelClasses() {
      return [
        'field__label',
        this.required && 'field__label_is-required'
      ]
    },

    classes() {
      return [
        'field__input',
        this.isSuccess && 'field__input_is-success'
      ]
    }
  },

  methods: {
    setFocus(data) {
      if (data) {
        this.$refs.input?.focus();
      }
    },
    clear(){
      this.changeValue({target:{value:''}});
    },
    changeValue(event) {
      if (this.min !== null && event.target.value < this.min) {
        event.target.value = this.min
      }
      if (this.max !== null && event.target.value > this.max) {
        event.target.value = this.max
      }
      this.$emit('update:error', null);
      this.$emit('update:modelValue', event.target.value);
    },

    handleTextInput(event) {
      if (!this.updateModelOnInput) {
        return
      }

      this.changeValue(event)
    }
  }
}
</script>

<style lang="scss" scoped>
.field__input {
  .field__label {
    &_is-required {
      &::after {
        content: '';
        position: relative;
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin-left: 5px;
        bottom: 7px;
        background: #D92121;
      }
    }
  }

  &.field__input_is-success {
    & > input {
      border: 1px solid #6aaf67;
      padding-right: 40px;

      &:focus {
        border: 1px solid #6aaf67;
      }
    }

    .clear.visible {
      right: 40px;
    }
  }

  .success-check {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    fill: #6aaf67;
    width: 30px;
    height: 30px;
  }
}
</style>
